module.exports = __webpack_public_path__ + "img/iphonex-rockies.ccaed953.png";